import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const ArtikelAssetServiceConfig = {
  name: "ArtikelAsset",
  annotations: []
} as ServiceConfig;